// extracted by mini-css-extract-plugin
module.exports = {"overlay":"Notifications_overlay__4G6iD","paper":"Notifications_paper__1zqNk","items":"Notifications_items__2ciMj","item":"Notifications_item__3YOwi"};